import { render, staticRenderFns } from "./ScrollableProductList.vue?vue&type=template&id=1603b558&scoped=true"
import script from "./ScrollableProductList.vue?vue&type=script&lang=js"
export * from "./ScrollableProductList.vue?vue&type=script&lang=js"
import style0 from "./ScrollableProductList.vue?vue&type=style&index=0&id=1603b558&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1603b558",
  null
  
)

export default component.exports